var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRestoreProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4911_2659)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.978,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0449 1.32031C68.8095 6.17275 73.6141 11.0067 78.459 15.8223C73.6547 15.9102 68.8499 15.9394 64.0449 15.9102C64.0449 11.0469 64.0449 6.1836 64.0449 1.32031Z",
    fill: "#EDBB33"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5383 -0.0859375C27.9486 -0.0859375 43.3586 -0.0859375 58.7688 -0.0859375C58.7395 6.12527 58.7688 12.3362 58.8567 18.5469C59.0032 20.0995 59.8529 20.9493 61.4056 21.0957C67.5576 21.1836 73.7099 21.2129 79.8626 21.1836C79.892 41.8087 79.8626 62.4336 79.7747 83.0586C78.8691 84.6362 77.5507 85.0757 75.8196 84.3769C75.297 84.0667 74.9161 83.6272 74.6771 83.0586C74.6711 69.696 74.554 56.3367 74.3255 42.9805C73.1244 36.8575 69.4622 33.1952 63.3392 31.9941C55.9599 31.7711 48.577 31.6538 41.1907 31.6426C39.968 29.9881 38.7669 28.3182 37.5872 26.6328C34.9169 23.149 31.3719 21.3618 26.9524 21.2715C21.6206 21.1836 16.2887 21.1542 10.9563 21.1836C10.927 14.6208 10.9563 8.05832 11.0442 1.49609C11.3409 0.760416 11.8389 0.233072 12.5383 -0.0859375Z",
    fill: "#EDBB33"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4121 38.5821C90.4121 54.4024 90.4121 70.2227 90.4121 86.0431C90.0686 86.8455 89.6292 87.6072 89.0938 88.3282C88.3303 89.0164 87.4806 89.5437 86.5449 89.9103C61.5255 89.9103 36.5058 89.9103 11.4863 89.9103C5.50977 88.504 1.81836 84.8126 0.412109 78.836C0.412109 63.4258 0.412109 48.0157 0.412109 32.6055C1.31767 29.4443 3.36845 27.4228 6.56445 26.5411C13.9473 26.4238 21.3301 26.4238 28.7129 26.5411C30.1473 26.9067 31.4363 27.5513 32.5801 28.4747C34.475 30.8874 36.262 33.3776 37.9414 35.9454C38.2457 36.3175 38.6266 36.5812 39.084 36.7364C47.1047 36.9663 55.1321 37.0835 63.166 37.0879C66.3594 37.9375 68.3809 39.959 69.2305 43.1524C69.2352 56.6327 69.3525 70.1094 69.582 83.5821C70.977 88.1384 74.0532 90.1599 78.8105 89.6466C82.004 88.797 84.0255 86.7755 84.875 83.5821C85.1346 68.0585 85.2225 52.5312 85.1387 37.0001C86.3705 36.9709 87.601 37.0001 88.8301 37.0879C89.5657 37.3847 90.0931 37.8827 90.4121 38.5821ZM45.5879 47.5469C49.4045 47.4689 53.2129 47.5568 57.0137 47.8106C58.3856 48.4752 58.8836 49.5591 58.5078 51.0626C58.075 52.115 57.284 52.6717 56.1348 52.7325C52.3187 52.8984 48.5101 52.8397 44.709 52.5567C43.337 51.8921 42.839 50.8082 43.2148 49.3048C43.6859 48.2657 44.477 47.6797 45.5879 47.5469ZM45.5879 58.0938C49.4045 58.0158 53.2129 58.1037 57.0137 58.3575C58.3856 59.0221 58.8836 60.106 58.5078 61.6094C58.075 62.6618 57.284 63.2186 56.1348 63.2794C52.3187 63.4453 48.5101 63.3866 44.709 63.1036C43.337 62.439 42.839 61.3551 43.2148 59.8516C43.6859 58.8126 44.477 58.2265 45.5879 58.0938Z",
    fill: "#EDBB33"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4911_2659)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 58,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#024E24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5 83C66.9075 83 63.1184 79.5602 62.5686 75.1164L64.5533 74.8683C64.981 78.3246 67.928 81 71.5 81C75.366 81 78.5 77.866 78.5 74C78.5 70.134 75.366 67 71.5 67C69.1212 67 67.0196 68.1865 65.7547 70H69.5V72H62.5V65H64.5V68.3427C66.15 66.3037 68.6727 65 71.5 65C76.4706 65 80.5 69.0294 80.5 74C80.5 78.9706 76.4706 83 71.5 83Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4911_2659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4911_2659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 58,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRestoreProject);
export default __webpack_public_path__ + "static/media/logo-restoreProject.ff712ae2823cf44e3a146427d6fcc4c8.svg";
export { ForwardRef as ReactComponent };